import { render, staticRenderFns } from "./driver-settlement-modal.vue?vue&type=template&id=1e4787b4&scoped=true"
import script from "./driver-settlement-modal.vue?vue&type=script&lang=js"
export * from "./driver-settlement-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4787b4",
  null
  
)

export default component.exports